/**
 * Static drive-time table between Morocco's main destinations, closest first.
 *
 * Read by the "Cities near {city}" section and, when a hub has no coordinates
 * to measure from, by the "book nearby" rail on an empty hub. Distances and
 * durations are approximate driving values along the standard route: good
 * enough for trip-planning context, not for turn-by-turn navigation.
 */
export interface NearbyEdge {
  slug: string;
  hours: number;
  km: number;
}

export const NEARBY_CITIES: Record<string, NearbyEdge[]> = {
  marrakech: [
    { slug: "agafay", hours: 0.75, km: 30 },
    { slug: "essaouira", hours: 2.5, km: 180 },
    { slug: "casablanca", hours: 2.5, km: 240 },
    { slug: "agadir", hours: 2.5, km: 250 },
    { slug: "ouarzazate", hours: 4, km: 200 },
    { slug: "fez", hours: 5, km: 530 },
  ],
  casablanca: [
    { slug: "rabat", hours: 1, km: 90 },
    { slug: "marrakech", hours: 2.5, km: 240 },
    { slug: "fez", hours: 3.5, km: 290 },
    { slug: "essaouira", hours: 4, km: 380 },
    { slug: "tangier", hours: 3.5, km: 340 },
  ],
  rabat: [
    { slug: "casablanca", hours: 1, km: 90 },
    { slug: "fez", hours: 2.5, km: 200 },
    { slug: "tangier", hours: 3, km: 250 },
    { slug: "chefchaouen", hours: 3.5, km: 280 },
    { slug: "marrakech", hours: 3.5, km: 330 },
  ],
  fez: [
    { slug: "rabat", hours: 2.5, km: 200 },
    { slug: "chefchaouen", hours: 3.5, km: 200 },
    { slug: "casablanca", hours: 3.5, km: 290 },
    { slug: "tangier", hours: 4, km: 330 },
    { slug: "marrakech", hours: 5, km: 530 },
  ],
  tangier: [
    { slug: "tetouan", hours: 1, km: 60 },
    { slug: "chefchaouen", hours: 2, km: 110 },
    { slug: "rabat", hours: 3, km: 250 },
    { slug: "fez", hours: 4, km: 330 },
  ],
  tetouan: [
    { slug: "tangier", hours: 1, km: 60 },
    { slug: "chefchaouen", hours: 1.5, km: 65 },
    { slug: "fez", hours: 4, km: 290 },
    { slug: "rabat", hours: 4, km: 310 },
  ],
  chefchaouen: [
    { slug: "tetouan", hours: 1.5, km: 65 },
    { slug: "tangier", hours: 2, km: 110 },
    { slug: "fez", hours: 3.5, km: 200 },
    { slug: "rabat", hours: 3.5, km: 280 },
  ],
  essaouira: [
    { slug: "marrakech", hours: 2.5, km: 180 },
    { slug: "agadir", hours: 2.5, km: 175 },
    { slug: "agafay", hours: 3, km: 200 },
    { slug: "casablanca", hours: 4, km: 380 },
  ],
  agadir: [
    { slug: "essaouira", hours: 2.5, km: 175 },
    { slug: "marrakech", hours: 2.5, km: 250 },
    { slug: "agafay", hours: 3, km: 270 },
    { slug: "ouarzazate", hours: 6, km: 380 },
  ],
  agafay: [
    { slug: "marrakech", hours: 0.75, km: 30 },
    { slug: "essaouira", hours: 3, km: 200 },
    { slug: "ouarzazate", hours: 4, km: 220 },
    { slug: "casablanca", hours: 3, km: 250 },
  ],
  ouarzazate: [
    { slug: "marrakech", hours: 4, km: 200 },
    { slug: "agafay", hours: 4, km: 220 },
    { slug: "merzouga", hours: 5, km: 360 },
    { slug: "agadir", hours: 6, km: 380 },
  ],
  merzouga: [
    { slug: "ouarzazate", hours: 5, km: 360 },
    { slug: "fez", hours: 7, km: 470 },
    { slug: "marrakech", hours: 9, km: 560 },
  ],
};
